import React, { createContext, useEffect, useState } from 'react';

export const LoadingContext = createContext();


const LoadingContextProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);

    useEffect(()=>{
        window.scrollTo({
            top:0,
            behavior: 'smooth'
        })
    },[loading]);

    return <LoadingContext.Provider value={{ loading, setLoading }}>
        {children}
    </LoadingContext.Provider>;
};

export default LoadingContextProvider;